

export default {
  fetchMovies() {
    const axios = require("axios");

    axios({
      "method": "GET",
      "url": "https://movie-database-imdb-alternative.p.rapidapi.com/",
      "headers": {
        "content-type": "application/octet-stream",
        "x-rapidapi-host": "movie-database-imdb-alternative.p.rapidapi.com",
        "x-rapidapi-key": "e6ac4468c8mshfaa5af835fb6c67p117fa5jsn1064f336664a"
      }, "params": {
        "i": "tt4154796",
        "r": "json"
      }
    })
      .then((response) => {
        console.log(response)
        return response
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

